import React, { useState, useEffect } from "react";
import API from "../Service/Baseservice";
import "../Admin/Admin.css";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
const AdminAdd = () => {
    const [formData, setFormData] = useState({
        admin_name: "",
        email: "",
        password: "",
        phone_number: "",
        admin_image: "",
        createdBy: "1",
        updatedBy: "1",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [emailError, setEmailError] = useState("");
    const [previewImage, setPreviewImage] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "",
    });
    const navigate = useNavigate();

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    useEffect(() => {
        if (!selectedImage) return;

        toBase64(selectedImage)
            .then((base64) => {
                const uploadPayload = {
                    name: "Admin Image",
                    image: [
                        {
                            name: selectedImage.name,
                            type: selectedImage.type,
                            size: `${selectedImage.size} bytes`,
                            base64: base64,
                        },
                    ],
                };
                return API.post("imageUpload/add", uploadPayload);
            })
            .then((res) => {
                if (res.data && res.data.success && res.data.url) {
                    setFormData((prev) => ({
                        ...prev,
                        admin_image: res.data.url,
                    }));
                } else {
                    throw new Error("Upload failed");
                }
            })
            .catch((err) => {
                console.error("Image upload failed:", err);
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Image upload failed. Please try again.",
                    type: "error",
                });
            });
    }, [selectedImage]);


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(file);
            setPreviewImage(URL.createObjectURL(file));
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.admin_name || !formData.email || !formData.password) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all required fields.",
                type: "info",
            });
            return;
        }

        // ✅ Email format validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(formData.email)) {
            setEmailError("Please enter a valid email address.");
            setPopup({
                show: true,
                title: "Warning",
                message: "Invalid email format.",
                type: "info",
            });
            return;
        } else {
            setEmailError("");
        }


        API.post("add_admin/add", formData)
            .then((res) => {
                if (res.data?.success) {
                    setPopup({
                        show: true,
                        title: "Success",
                        message: res.data?.message || "Admin added successfully!",
                        type: "success",
                    });
                    // setTimeout(() => navigate("/admin"), 3500);
                } else {

                    const errorMessage =
                        res.data?.error?.message ||
                        res.data?.message ||
                        "Failed to add admin!";
                    setPopup({
                        show: true,
                        title: "Error",
                        message: errorMessage,
                        type: "error",
                    });
                }
            })
            .catch((err) => {
                console.error("Failed to add admin:", err);
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Failed to add admin. Please try again.",
                    type: "error",
                });
            });

    };

    return (
        <div className="admin-form-container">
            <div className="newsadd-header">
                <h2 className="newsadd-title">Add New Admin</h2>
                <div className="header-buttons">
                    <button onClick={handleSubmit} className="btn saves-btn" >
                        Save
                    </button>
                    <button onClick={() => navigate("/admin")} className="cancel-btn ">
                        Back
                    </button>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="admin-form-page">
                <div className="image-upload-container">
                    <label htmlFor="admin_image" className="image-label">
                        {previewImage ? (
                            <img src={previewImage} alt="Preview" className="admin-image-preview" />
                        ) : (
                            <div className="image-placeholder">+</div>
                        )}
                    </label>
                    <input
                        type="file"
                        id="admin_image"
                        name="admin_image"
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                    />
                    <p className="image-note">Click the circle to upload image</p>
                </div>

                {/* ===== Row 1: Name + Email ===== */}
                <div className="admin-form-row">
                    <div className="admin-form-group">
                        <label>Admin Name <span style={{ color: "red" }}>*</span></label>
                        <input
                            type="text"
                            name="admin_name"
                            value={formData.admin_name}
                            onChange={handleChange}
                            placeholder="Enter admin name"
                        />
                    </div>
                    <div className="admin-form-group">
                        <label>
                            Email <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="email"
                            name="email"
                            autoComplete="off"
                            value={formData.email}
                            placeholder="Enter email"
                            onChange={(e) => {
                                const value = e.target.value;
                                setFormData({ ...formData, email: value });


                                const emailPattern = /^[^\s@]+@[^\s@]+\.com$/;
                                if (value && !emailPattern.test(value)) {
                                    setEmailError("Please enter a valid email address");
                                } else {
                                    setEmailError("");
                                }
                            }}
                        />

                        {emailError && (
                            <span style={{ color: "red", fontSize: "12px" }}>{emailError}</span>
                        )}
                    </div>

                </div>

                {/* ===== Row 2: Password + Phone ===== */}
                <div className="admin-form-row">
                    <div className="admin-form-group">
                        <label>
                            Password <span style={{ color: "red" }}>*</span>
                        </label>

                        <div className="password-input-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                autoComplete="new-password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Enter password"
                            />
                            <span
                                className="password-toggle-icon"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                            </span>
                        </div>
                    </div>


                    <div className="admin-form-group">
                        <label>
                            Phone Number <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="text"
                            name="phone_number"
                            value={formData.phone_number}
                            placeholder="Enter phone number"
                            onChange={(e) => {
                                const value = e.target.value;

                                if (/^\d{0,10}$/.test(value)) {
                                    setFormData({ ...formData, phone_number: value });
                                }
                            }}
                        />
                    </div>

                </div>
            </form>

            {/* Popup */}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box ${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                            <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/admin"); // ✅ redirect ONLY on OK
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminAdd;
